import articles from '../data/articles.json';

// Pre-import all markdown files for Vite compatibility
import whatToEatWhenSad from '../content/what-to-eat-when-sad.md?raw';
import whatToEatWhenStressed from '../content/what-to-eat-when-stressed.md?raw';
import whatToEatWhenTired from '../content/what-to-eat-when-tired.md?raw';
import foodForStress from '../content/food-for-stress.md?raw';
import foodForAnxiety from '../content/food-for-anxiety.md?raw';
import comfortFoodIdeas from '../content/comfort-food-ideas.md?raw';

const articleContents = {
  'what-to-eat-when-sad.md': whatToEatWhenSad,
  'what-to-eat-when-stressed.md': whatToEatWhenStressed,
  'what-to-eat-when-tired.md': whatToEatWhenTired,
  'food-for-stress.md': foodForStress,
  'food-for-anxiety.md': foodForAnxiety,
  'comfort-food-ideas.md': comfortFoodIdeas
};

export async function loadArticle(slug) {
  const articleMeta = articles.find(a => a.slug === slug);
  if (!articleMeta) {
    return null;
  }

  const content = articleContents[articleMeta.file];
  if (!content) {
    return null;
  }

  return {
    ...articleMeta,
    content
  };
}

export function getAllArticles() {
  return articles;
}

export function getRelatedArticles(currentSlug, limit = 2) {
  return articles
    .filter(a => a.slug !== currentSlug)
    .slice(0, limit);
}
